module.exports = __webpack_public_path__ + "0e2ee061784f409d030bb727d313b7f5.svg";